import * as tslib_1 from "tslib";
import { isNumeric } from '../../util/helpers';
import { parseLatLon } from '../../airport/util/parseUtils';
import { BusinessFinderResult } from './business-finder-result.model';
/**
 * Tag-name prefix carried by degree tags (Associates / Bachelors / ...). The last `::` segment is shown on
 * the results card as the degrees the university offers.
 */
export var UNIVERSITY_DEGREE_PREFIX = 'College::Degrees::';
/**
 * Tag name marking a university approved for VA (GI Bill) benefits.
 */
export var UNIVERSITY_VA_APPROVED_TAG = 'College::Approved for VA';
/**
 * Tag name marking a university that offers distance learning.
 */
export var UNIVERSITY_DISTANCE_LEARNING_TAG = 'College::Distance Learning';
/**
 * A university search result returned by the AirportsAPI `~/universities` endpoint. A university (aka college)
 * is a business carrying any "College" tag, mirroring the iOS app's `tagPrefix: "College"` classification.
 * Mirrors {@link FlyingClubResult}'s `static parse` convention.
 */
var UniversityResult = /** @class */ (function (_super) {
    tslib_1.__extends(UniversityResult, _super);
    function UniversityResult() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UniversityResult.parse = function (data) {
        var tags = (data.tags || []).map(function (d) { return d; });
        var degrees = tags
            .filter(function (t) { return t.indexOf(UNIVERSITY_DEGREE_PREFIX) === 0; })
            .map(function (t) { return t.substring(UNIVERSITY_DEGREE_PREFIX.length); });
        return Object.assign(new UniversityResult(), {
            businessId: data.businessId,
            name: data.name || null,
            city: data.city || null,
            stateProvince: data.stateProvince || null,
            latitude: isNumeric(data.latitude) ? +data.latitude : null,
            longitude: isNumeric(data.longitude) ? +data.longitude : null,
            location: (isNumeric(data.latitude) && isNumeric(data.longitude))
                ? parseLatLon(data.latitude, data.longitude) : null,
            phone1: data.phone1 || null,
            webAddress: data.webAddress || null,
            emailAddress: data.emailAddress || null,
            description: data.description || null,
            distance: isNumeric(data.distance) ? +data.distance : null,
            airportIdent: data.airportIdent || null,
            airportName: data.airportName || null,
            tags: tags,
            degrees: degrees,
            vaApproved: tags.indexOf(UNIVERSITY_VA_APPROVED_TAG) !== -1,
            distanceLearning: tags.indexOf(UNIVERSITY_DISTANCE_LEARNING_TAG) !== -1,
            thumbnailPhotoPath: data.thumbnailPhotoPath || null
        });
    };
    return UniversityResult;
}(BusinessFinderResult));
export { UniversityResult };
